import api from "./api";

const feeHeadService = {
    getAll: (params = {}) => api.get("/fee-heads", { params }),
    create: (data) => api.post("/fee-heads", data),
};

export default feeHeadService;